<template>
  <UtilButton v-if="canShare" @click="shareListing(listing)" textLink class="text-primary">
    <FontAwesomeIcon :icon="faShareAlt" fixed-width />
    <span>Share</span>
  </UtilButton>
</template>

<script>
import { faShareAlt } from '@fortawesome/pro-regular-svg-icons'
import { canShare, shareListing } from '@/lib/share-listing'
import UtilButton from '@/components/utils/UtilButton'

export default {
  name: 'ListingShare',
  components: {
    UtilButton
  },
  props: {
    listing: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      canShare,
      shareListing,
      faShareAlt
    }
  }
}
</script>
